import { render, staticRenderFns } from "./NewsUpdatesFeed.vue?vue&type=template&id=b7830da6&scoped=true"
import script from "./NewsUpdatesFeed.vue?vue&type=script&lang=js"
export * from "./NewsUpdatesFeed.vue?vue&type=script&lang=js"
import style0 from "./NewsUpdatesFeed.vue?vue&type=style&index=0&id=b7830da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7830da6",
  null
  
)

export default component.exports